import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes as ReactRouterRoutes, matchPath, useLocation } from "react-router-dom";

import isAuthenticated from '../services/auth';

import Sidebar from '../components/Sidebar';
import Icon from '../components/Icon';
import Login from '../pages/Login';
import privateRoutes, { getInitialPath } from './privateRoutes';

// Rotas sem o shell do painel: padrões (matchPath), não prefixos.
const NO_SIDEBAR_ROUTES = [
    '/login',
];

// Monta o Sidebar uma vez, fora do <Routes>, para não remontar a cada navegação.
const PanelShell = ({ children }) => {
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        setSidebarOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        document.body.classList.toggle('sidebar-mobile-open', sidebarOpen);
        return () => document.body.classList.remove('sidebar-mobile-open');
    }, [sidebarOpen]);

    const hideSidebar = !isAuthenticated()
        || NO_SIDEBAR_ROUTES.some((pattern) => matchPath(pattern, location.pathname));

    if (hideSidebar) {
        return children;
    }

    return (
        <main id="panel" className={sidebarOpen ? 'sidebar-open' : ''}>
            <button
                type="button"
                className="mobile-menu-button"
                aria-label="Abrir menu"
                aria-expanded={sidebarOpen}
                onClick={() => setSidebarOpen(true)}
            >
                <Icon name="menu" size={22} />
            </button>
            <button
                type="button"
                className="sidebar-overlay"
                aria-label="Fechar menu"
                onClick={() => setSidebarOpen(false)}
            />
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            {children}
        </main>
    );
};

const Routes = () => {
    const RequireAuth = ({children, route}) => {
        let location = useLocation();

        if(!isAuthenticated()){
            return <Navigate to="/login" state={{ from: location }} />;
        }

        if(!route.show){
            let initialPath = getInitialPath();
            return <Navigate to={initialPath} state={{ from: location }} />;
        }

        return children;
    };

    return (
        <BrowserRouter>
            <PanelShell>
                <ReactRouterRoutes>
                    <Route exact path="/" element={isAuthenticated() ? <Navigate to="/product/list" /> : <Navigate to="/login" /> } />
                    <Route path="/login" element={<Login />} />

                    {privateRoutes.map((privateRoute, index) => (
                        <Route key={index} path={privateRoute.path} element={<RequireAuth route={privateRoute}>{privateRoute.element}</RequireAuth>} />
                    ))}
                </ReactRouterRoutes>
            </PanelShell>
        </BrowserRouter>
    );
}

export default Routes;
